import UserOperatorListRequest, {
  UserOperatorListRequestQueryParams,
} from "./user-operator-list.request";

const createQueryParams = (
  data: UserOperatorListRequest,
): UserOperatorListRequestQueryParams => {
  return {
    creationEnd: data.creationEnd,
    creationStart: data.creationStart,
    limit: data.limit,
    offset: data.offset,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    username: data.username,
    order: data.order,
    statusCriteria: data.statusCriteria,
  };
};

const userOperatorListRequestFactory = {
  createQueryParams,
};

export default userOperatorListRequestFactory;
